module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Phone-b9617001778607b85235937138330656.svg";